{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              30.933519409629554,
              69.75793141092834
            ],
            [
              31.84268606436052,
              70.99333126565975
            ],
            [
              20.49484984837349,
              71.7694811929882
            ],
            [
              2.4883804452623792,
              63.1536022385867
            ],
            [
              4.52534424180638,
              59.06351010379646
            ],
            [
              6.8652479589475774,
              57.43956684363684
            ],
            [
              10.84913107651073,
              58.92598243491727
            ],
            [
              11.59790884237674,
              58.898480411891256
            ],
            [
              12.42923225696552,
              60.08262900252703
            ],
            [
              11.965770325904913,
              63.20792248208613
            ],
            [
              12.756373598520184,
              64.01795633842067
            ],
            [
              14.193109376326305,
              64.1302341525739
            ],
            [
              14.48325283532185,
              65.39323080242673
            ],
            [
              17.088786108526023,
              68.12770127536479
            ],
            [
              23.76720954385496,
              68.74493046601023
            ],
            [
              25.746286488091584,
              68.90038079185248
            ],
            [
              26.749650738611336,
              69.9465219021796
            ],
            [
              30.933519409629554,
              69.75793141092834
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}